import React from 'react';
import { Typography } from 'seagull';
import styles from "./DeliveryRejected.module.scss";
import { SuccessPage } from "../../components/SuccessPage";
import Rejected from "../assets/rejected.svg";
export function DeliveryRejected(_ref) {
  let {
    relationship
  } = _ref;
  return /*#__PURE__*/React.createElement(SuccessPage, {
    image: /*#__PURE__*/React.createElement(Rejected, null),
    className: styles.gap
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    weight: "normal",
    className: styles.title
  }, "Delivery was rejected"), /*#__PURE__*/React.createElement(Typography, {
    "data-testid": "rejection-msg"
  }, relationship.vendor.name, " will be informed."));
}